import * as React from 'react';

import classNames from 'classnames';

import {formEncodedApi} from 'nutshell-core/api';

// @ts-expect-error
import {SidebarIconNotificationsIcon} from 'shells/icon/svg/sidebar-icon-notifications';
import {useInterval} from 'shells/utils/hooks/use-interval';

import {App as AppModule} from '../../../app/index';
import {store} from '../../../store';

import {NavbarIcon} from './navbar-icon';

type Props = {
    isOpen: boolean;
    size: number;
    onClick: () => void;
    getButtonRef: (element?: HTMLElement | null | undefined) => void;
};

const NOTIFICATION_POLL_MS = 300000; // 5 mins
const FAST_POLL_MS = 3000; // 3 seconds
const FAST_POLL_COUNT = 5;
export const TRIGGER_FAST_NOTIFICATION_POLL_EVENT = 'triggerFastNotificationPoll';

export function NotificationBellButton(props: Props) {
    const [count, setCount] = React.useState<number>(0);
    const {isOpen} = props;

    const unreadPoll = React.useCallback(() => {
        formEncodedApi
            // @ts-expect-error
            .post('/notification/count.json')
            // @ts-expect-error
            .then((res) => res.json())
            .then((json) => {
                setCount(json.unseen);

                // Hack alert! This is our way to reset the app version so the
                // frontend knows when to reload the app.
                if (json.appVersion) {
                    store.dispatch(AppModule.setAppVersion(json.appVersion));
                }
            });
    }, []);

    // listen for event to poll quickly several times when more immediate notification
    // is expected (ie. marketing automations test flow)
    React.useEffect(() => {
        const handleFastPollTrigger = () => {
            for (let i = 0; i < FAST_POLL_COUNT; i++) {
                setTimeout(unreadPoll, i * FAST_POLL_MS);
            }
        };

        window.addEventListener(TRIGGER_FAST_NOTIFICATION_POLL_EVENT, handleFastPollTrigger);

        return () => {
            window.removeEventListener(TRIGGER_FAST_NOTIFICATION_POLL_EVENT, handleFastPollTrigger);
        };
    }, [unreadPoll]);

    React.useEffect(() => {
        unreadPoll();
    }, [unreadPoll, isOpen]);

    useInterval(unreadPoll, NOTIFICATION_POLL_MS);

    const displayedCountText = count && count > 99 ? '99+' : count;

    const notificationButtonClasses = classNames({
        'nut-navbar--button--notifications--active': isOpen,
        'nut-navbar--button--notifications': !isOpen,
        'nut-navbar--notification-badge--new--has-badge': count > 0,
    });

    return (
        // @ts-expect-error
        <button
            className={notificationButtonClasses}
            ref={props.getButtonRef}
            type='button'
            aria-expanded={String(isOpen)}
            onClick={() => props.onClick()}
            data-tip='Notifications'
            data-place='bottom'
            data-delay-show={50}
        >
            <div className='flex'>
                <NavbarIcon icon={SidebarIconNotificationsIcon} size={props.size} />
                <span
                    id='navbar-notifications-badge'
                    data-count={displayedCountText}
                    className='nut-navbar--notification-badge--new'
                >
                    {displayedCountText}
                </span>
            </div>
        </button>
    );
}
